// extracted by mini-css-extract-plugin
module.exports = {"pagination":"AllActivities_pagination__3X7Ue","activity_page":"AllActivities_activity_page__1Gx5y","activity_modal":"AllActivities_activity_modal__25pwX"};